
import React, { Fragment } from 'react';

const datas = {
    week: { first: '1st', second: '2nd', third: '3rd', forth: '4th' },
    dayOfTheMonth: {
        1: '1st', 2: '2nd', 3: '3rd', 4: '4th', 5: '5th', 6: '6th', 7: '7th', 8: '8th', 9: '9th', 10: "10th",
        11: '11th', 12: '12th', 13: '13th', 14: '14th', 15: '15th', 16: '16th', 17: '17th', 18: '18th', 19: '19th', 20: '20th',
        21: '21st', 22: '22nd', 23: '23rd', 24: '24th', 25: '25th', 26: '26th', 27: '27th', 28: '28th', 29: '29th', 30: '30th', 31: '31st',
    },
};

export const Monthly = (props) => {
    const { FormControl, clsx, classes, changeEveryHandler,
        FormGroup, Checkbox, FormControlLabel, every, view } = props;

    return (
        <>
            <FormControl
                tabIndex={-1}
                className={clsx(classes.margin20t, classes.customRadioButton, classes.customRadioButtonMonthly)}
                variant={'standard'}
                fullWidth>
                <div className={classes.frequencyEveryPos}>
                    <div className={clsx(classes.frequencyEveryText, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Every</div>
                    <FormGroup aria-label="position" row>
                        {
                            Object?.entries(datas['dayOfTheMonth'])?.map(([key, value]) => (
                                <FormControlLabel
                                    key={key}
                                    disabled={view}
                                    name={`every_${key}`}
                                    checked={every[`every_${key}`]}
                                    control={<Checkbox size={'small'} checked={every[`every_${key}`]}
                                        onChange={(e) => changeEveryHandler(e)}
                                    />}
                                    label={value}
                                    labelPlacement="end"
                                />
                            ))
                        }
                    </FormGroup>
                </div>
            </FormControl>
        </>
    )
}

export const MonthlyListView = (props) => {
    return (
        <>
            {
                Object?.entries(datas['dayOfTheMonth'])?.map(([key, value]) => (
                    <Fragment key={key}> {props?.data[`every_${key}`] ?
                        <span className={props.classes.everyDis}>{value}</span> : ''}</Fragment>
                ))
            }
        </>
    )
}